import React from 'react';
import { useAuth } from '../utils/AuthContext/AuthContext';  // Ensure the path is correct
import { useFormContext } from "../utils/FormContext.jsx"; 
import { useMediaQuery } from 'react-responsive';
import SaveSVG from '../assets/Save.jsx';
import config from '../utils/config.js'; // Ensure the path is correct

function SaveButton() {
    const { token, user } = useAuth(); // Use user and token from context
    const { handleSave, formData, formId } = useFormContext(); // Use handleSave from context
    const isMobile = useMediaQuery({ query: '(max-width: 768px)' });

return (
  <div>
    <button onClick={handleSave} className='text-shi-green px-2 py-[3px] h-[30px] text-[14px] md:text-sm rounded-md flex items-center border font-light border-slate-700 hover:bg-slate-200 hover:text-shi-deep-purple'>
    <object id="pdfObject" type="application/pdf" className='w-[0px] h-[0px]'></object>
        {isMobile ? <SaveSVG width={20} height={20} /> : 'Save'}
    </button>
    </div>
);
}

export default SaveButton;